import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ITEM_ATA.BLOQUEIO.HISTORICO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ITEM_ATA.BLOQUEIO.HISTORICO.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
}
